/// <amd-module name="VSS/Features/Search/Coordinator" />
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IContributedSearchProvider, ISearchCoordinator, ISearchProvider, ISearchQuery, ISearchStatus } from "VSS/Platform/Search";

/**
 * This search coordinator is used to run the ISearchProviders in process and the
 * results are made available to the caller directly.
 */
class InProcessSearchCoordinator extends VssService implements ISearchCoordinator {
    public execute(searchQuery: ISearchQuery): Promise<ISearchStatus> {
        // Retrieve the set of search providers that are currently available.
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");

        // Resolve the providerId to the contributed serarch provider.
        return contributionService.getContributionAsync<IContributedSearchProvider>(searchQuery.providerId).then(contributedProvider => {
            if (contributedProvider) {
                return contributionService.getService<ISearchProvider>(searchQuery.providerId).then(searchProvider => {
                    if (searchProvider) {
                        // If we successfully resolved the search provider, we will execute the query and return
                        // the result of the query as the search promise.
                        return searchProvider.execute(searchQuery);
                    }

                    throw new Error("Unable to create search provider service for '" + searchQuery.providerId + "'.");
                });
            }

            throw new Error("Search provider '" + searchQuery.providerId + "' was not defined.");
        });
    }
}

Services.add("inprocess-search-coordinator", { serviceFactory: InProcessSearchCoordinator });
